export default {"src":"/_next/static/media/explore.2f980940.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};